import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Button } from 'app/design/primitives/button';
import React from 'react';
import { Trans } from 'react-i18next';
import { OFFER_CARD_WIDTH } from 'app/components/listing-offer-card';

import { Gradient } from 'app/design/primitives/gradient';
import { useDistanceUnit } from 'app/hooks/use-distance-unit';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export function RemoveDistanceFilterPrompt({
  searchDistance,
  onTrigger,
}: {
  searchDistance: number;
  onTrigger: () => void;
}) {
  const { convertDistance } = useDistanceUnit();
  return (
    <>
      <Column alignItems="center">
        <Row alignItems="center" gap="spacing.general.x4" marginTop="spacing.general.x4">
          <Gradient
            borderRadius={theme.borderRadii['radius.lg']}
            from="#EEECE7"
            style={{ height: 102, width: OFFER_CARD_WIDTH }}
            to="#ffffff"
            toOpacity={0}
          />
        </Row>
      </Column>

      <Column alignItems="center" style={{ marginTop: -64 }}>
        <Button onPress={onTrigger} style={{ backgroundColor: theme.colors['surface.default'] }} variant="secondary">
          <Text>
            <Trans
              components={{ strong: <Text fontWeight="700" /> }}
              i18nKey="moreResultsWithoutDistanceFilter"
              ns="all-listings"
              values={{ distance: convertDistance(searchDistance, { withUnit: true }) }}
            />
          </Text>
        </Button>
      </Column>
    </>
  );
}
